import { add } from "date-fns";
import React from "react";

import { HStack } from "@whoosh/design-system/src/components/primitive";

import { WeekDay } from "./WeekDay";

type WeekRowProps = {
  startDateObj: Date;
  monthDateObj: Date;
};

export const WeekRow = ({ startDateObj, monthDateObj }: WeekRowProps) => {
  const weekArray = Array(7).fill(0);
  return (
    <HStack justifyContent="space-between">
      {weekArray.map((_, i) => {
        const curDateObj = add(startDateObj, { days: i });

        return (
          <WeekDay
            position={i}
            key={`day-${curDateObj.toString()}`}
            curDateObj={curDateObj}
            monthDateObj={monthDateObj}
          />
        );
      })}
    </HStack>
  );
};
